{
  "title": "Settings",
  "subtitle": "Configure your organization and account",
  "back": "Settings",
  "save": "Save changes",
  "saved": "Changes saved",
  "savedApplied": "Saved and applied to {{count}} enrollments",
  "groups": {
    "org": "Organization",
    "account": "Account"
  },
  "sections": {
    "organization": {
      "title": "Organization info",
      "desc": "Name, logo and brand colour shown on the tuition slip and progress page parents open."
    },
    "members": {
      "title": "Members & permissions",
      "desc": "Who can access your classes and do what — plus teacher pay rates."
    },
    "branches": {
      "title": "Branches",
      "desc": "Your locations. Filter classes, attendance and payroll by each one."
    },
    "bank": {
      "title": "Bank",
      "desc": "The account that receives tuition and auto-reconciles payments."
    },
    "billing": {
      "title": "Plan & billing",
      "desc": "Your current plan and LopHoc invoices."
    },
    "billing-rules": {
      "title": "Billing rules",
      "desc": "Settings that change the amount on invoices."
    },
    "display": {
      "title": "Display",
      "desc": "How LopHoc shows information — does not affect tuition."
    },
    "audit": {
      "title": "Activity log",
      "desc": "Who did what in this organisation, in order. Owners and admins only."
    },
    "profile": {
      "title": "Personal profile",
      "desc": "Your name and login email."
    },
    "password": {
      "title": "Password",
      "desc": "Change your login password."
    }
  },
  "billingRules": {
    "alert": "Settings here change the amount on invoices generated when a month is closed. Changes apply to every not-yet-closed period — already-closed periods do not change."
  },
  "profile": {
    "title": "Account",
    "fullName": "Full name",
    "email": "Email",
    "role": "Role",
    "password": "Password",
    "edit": "Edit",
    "cancel": "Cancel",
    "emailVerified": "Verified",
    "emailNotVerified": "Not verified",
    "resendVerify": "Resend verification email",
    "sending": "Sending...",
    "emailSent": "Sent!",
    "resendError": "Error, try again",
    "save": "Save",
    "saving": "Saving...",
    "nameUpdated": "Name updated",
    "security": {
      "open": "Change",
      "currentPassword": "Current password",
      "newPassword": "New password",
      "confirmPassword": "Confirm new password",
      "submit": "Change password",
      "submitting": "Changing...",
      "changed": "Password changed",
      "hint": "New password must be at least 8 characters.",
      "errCurrentRequired": "Please enter your current password",
      "errTooShort": "New password must be at least 8 characters",
      "errMismatch": "Passwords do not match",
      "errSameAsCurrent": "New password must differ from the current one",
      "errWrongCurrent": "Current password is incorrect"
    },
    "org": {
      "title": "Organization",
      "name": "Organization name",
      "logo": "Logo",
      "changeLogo": "Change logo",
      "noLogo": "No logo yet",
      "logoHint": "The logo appears on the tuition slip and progress page parents receive, and is the app icon when a parent installs the progress page.",
      "updated": "Organization updated",
      "readOnly": "Only the owner or an admin can change this.",
      "brandColor": "Brand colour",
      "brandColorHint": "Used on the progress page, the tuition slip parents receive and the app installed to a parent's phone. Attendance colours are unaffected.",
      "brandColorLocked": "Brand colour is available from the Pro plan",
      "brandColorSave": "Save",
      "brandColorReset": "Back to default",
      "brandColorCustom": "Custom"
    },
    "crop": {
      "title": "Crop logo",
      "description": "Drag to position, use the slider to zoom. The logo is cropped square.",
      "zoom": "Zoom",
      "choose": "Choose image",
      "confirm": "Use this image",
      "cancel": "Cancel",
      "uploading": "Uploading...",
      "errType": "Only PNG, JPG or WEBP images are accepted",
      "errSize": "Image must be smaller than 2 MB",
      "errUpload": "Upload failed, please try again"
    }
  },
  "team": {
    "title": "Members",
    "memberCount": "{{count}} members in organization",
    "seatCount": "{{used}} / {{max}} teacher seats",
    "invite": "Invite member",
    "empty": "No members yet",
    "you": "(you)",
    "pendingTitle": "Pending invitations",
    "pendingEmpty": "No pending invitations",
    "expires": "Expires {{date}}",
    "inviteTitle": "Invite member",
    "inviteDescription": "Send an email invitation to join the organization. Invitations expire in 7 days.",
    "inviteEmail": "Email",
    "inviteEmailPlaceholder": "colleague@example.com",
    "inviteRole": "Role",
    "inviteCancel": "Cancel",
    "inviteSubmit": "Send invitation",
    "inviteSubmitting": "Sending...",
    "toastInvited": "Invitation sent",
    "toastReactivated": "Member reactivated.",
    "toastAlreadyMember": "This person is already a member",
    "toastInviteError": "Could not send invitation",
    "toastRoleUpdated": "Role updated",
    "toastRoleError": "Could not update role",
    "toastRemoved": "Removed {{name}} — archived {{archivedSlots}} classes, cleared {{removedSessions}} sessions",
    "toastRemoveError": "Could not remove member",
    "removePreviewError": "Could not load removal information",
    "removeConfirmTitle": "Remove {{name}}?",
    "removeConfirmDescription": "This teacher still has {{activeSlots}} recurring classes + {{futureSessions}} upcoming sessions — classes will be archived and untaught sessions removed. Taught sessions and attendance are kept.",
    "removeConfirmAction": "Remove teacher",
    "revoke": "Revoke",
    "revokeConfirmTitle": "Revoke this invitation?",
    "revokeConfirmDescription": "The invitation sent to {{email}} will be cancelled and its seat freed immediately.",
    "revokeConfirmAction": "Revoke invitation",
    "toastInvitationRevoked": "Invitation revoked",
    "toastInvitationAlreadyAccepted": "This invitation was already accepted and can't be revoked",
    "toastInvitationRevokeError": "Could not revoke invitation",
    "addTeacher": "Add teacher",
    "addTeacherEmailMode": "Invite by email",
    "addTeacherQuickMode": "Quick add (no account needed)",
    "noAccountBadge": "No account yet",
    "convertAction": "Convert to account",
    "quickAddTitle": "Quick-add a teacher",
    "quickAddDescription": "Add a teacher by name only, no email or account required. You can convert them to a real account later.",
    "quickAddName": "Teacher name",
    "quickAddNamePlaceholder": "e.g. Ms. Lan",
    "quickAddSubmit": "Add teacher",
    "toastPlaceholderAdded": "Teacher added",
    "toastPlaceholderError": "Could not add teacher",
    "convertTitle": "Convert to account",
    "convertDescription": "Enter an email so the teacher receives a link to set a password and log in.",
    "convertEmail": "Email",
    "convertSubmit": "Send set-password link",
    "toastConverted": "Set-password link sent",
    "toastConvertError": "Could not convert to account",
    "toastConvertEmailExists": "This email already belongs to another account"
  },
  "bank": {
    "title": "Bank",
    "description": "Link a bank account to receive invoice payments via VietQR",
    "connected": "Connected",
    "unlink": "Unlink",
    "emptyTitle": "No bank accounts linked",
    "emptyDescription": "Link a bank account to get automatic notifications when clients pay",
    "linkButton": "Link bank account",
    "linking": "Connecting...",
    "linkError": "Could not link bank account",
    "unlinkError": "Could not unlink bank account",
    "reconcile": {
      "activeLabel": "Auto-reconcile: On",
      "offLabel": "Auto-reconcile: Off",
      "pausedLabel": "Auto-reconcile: Paused — monthly quota reached",
      "usage": "Used {{used}}/{{quota}} transactions this month",
      "unlimited": "Unlimited",
      "offSubtext": "Upgrade to auto-record payments",
      "offCta": "Upgrade",
      "pausedSubtext": "Will resume automatically next month, or upgrade your plan."
    },
    "primary": "Receives tuition",
    "usePrimary": "Use this account",
    "primaryHint": "The QR on every invoice prints the account marked Receives tuition. Other accounts stay linked: a transfer to them with the right content still auto-matches, without it lands in Unmatched transactions as usual.",
    "primaryConfirmTitle": "Change the receiving account?",
    "primaryConfirmBody": "The QR on every invoice will switch to {{bank}} {{account}} from the next open. The old account stays linked and keeps being reconciled as before.",
    "primaryConfirm": "Change",
    "primaryCancel": "Keep as is",
    "primarySaved": "Receiving account changed",
    "primaryError": "Could not change the receiving account"
  },
  "branches": {
    "title": "Branches",
    "description": "Every class belongs to a branch. Filter the timetable, attendance and payroll by branch — the money stays in one book.",
    "add": "Add branch",
    "addTitle": "Add branch",
    "nameLabel": "Branch name",
    "namePlaceholder": "Le Loi campus",
    "empty": "No branches yet",
    "emptyDescription": "Add your first location to filter classes by where they are taught.",
    "slotCount": "{{count}} classes",
    "slotCount_one": "1 class",
    "archivedBadge": "Archived",
    "showArchived": "Show archived branches",
    "hideArchived": "Hide archived branches",
    "rename": "Rename",
    "renameTitle": "Rename branch",
    "archive": "Archive",
    "archiveTitle": "Archive this branch?",
    "archiveBody": "It disappears from the picker and the class form. Existing classes keep its name.",
    "unarchive": "Restore",
    "created": "Branch added",
    "renamed": "Branch renamed",
    "archivedToast": "Branch archived",
    "unarchivedToast": "Branch restored",
    "error": "Could not save the branch",
    "upsellTitle": "A Center plan feature",
    "upsellBody": "Your branches are kept exactly as they are — upgrade to Center to switch filtering by location back on, add new branches and restore archived ones.",
    "upsellCta": "See the Center plan",
    "addFirstTitle": "Your first branch",
    "addFirstDesc": "Name the location you teach at. When you add another one later, new classes go there.",
    "create": "Create branch",
    "assignAllLabel": "Assign all {{count}} existing classes to this branch",
    "assignAllLabel_one": "Assign the 1 existing class to this branch",
    "assignAllHelp": "Every class, timetable slot and attendance record you already have will belong to this location. Nothing is deleted and no number changes, and you can move individual classes to another branch later, any time.",
    "assignAllOffWarning": "These {{count}} classes will not belong to any branch, so they will not show up when you filter by a location. Assign them later in Settings · Branches.",
    "assignAllOffWarning_one": "This class will not belong to any branch, so it will not show up when you filter by a location. Assign it later in Settings · Branches.",
    "unassignedWarning": "{{count}} classes do not belong to a branch. They do not show up when you filter by location.",
    "unassignedWarning_one": "1 class does not belong to a branch. It does not show up when you filter by location.",
    "bulkAssign": "Assign in bulk",
    "bulkAssignTitle": "Assign the classes with no branch",
    "bulkAssignDesc": "Choose the location that takes these {{count}} classes. You can move individual classes later, any time.",
    "bulkAssignDesc_one": "Choose the location that takes this class. You can move it later, any time.",
    "bulkAssignTarget": "Target branch",
    "bulkAssignDone": "Assigned {{count}} classes",
    "bulkAssignDone_one": "Assigned 1 class"
  },
  "preferences": {
    "industry": "Industry",
    "teamSize": "Team size",
    "preferredChannel": "Communication channel",
    "defaultCurrency": "Currency",
    "saving": "Saving...",
    "toastUpdated": "Preferences updated",
    "toastError": "Could not update",
    "language": "Language",
    "langVi": "Tiếng Việt",
    "langEn": "English",
    "IT_WEB": "IT / Web",
    "DESIGN": "Design",
    "CONTENT": "Content",
    "CONSULTING": "Consulting",
    "OTHER": "Other",
    "SOLO": "Teaching solo",
    "SMALL": "Have a teaching assistant",
    "MEDIUM": "Small center",
    "ZALO": "Zalo",
    "EMAIL": "Email",
    "BOTH_channel": "Both",
    "VND": "VND",
    "USD": "USD",
    "BOTH_currency": "Both",
    "businessType": "Business type",
    "businessTypeUnregistered": "Not registered",
    "businessTypeHousehold": "Household business (HKD)",
    "businessTypeEnterprise": "Enterprise (company)",
    "showTeacherAssignment": "Teacher assignment",
    "showTeacherAssignmentDesc": "Show teacher picker for classes/sessions (turn on when you have multiple teachers)",
    "classMode": "Class organization",
    "classModeCohort": "Group classes",
    "classModeIndividual": "One-on-one",
    "classModeHelper": "Sets the default for the Create class button, the class form, calendar colours and the Class column on Students. Does not change billing.",
    "sellsExtras": "Sell extra products/services",
    "sellsExtrasDesc": "Show the extra-sale invoice flow beyond course fees",
    "sellsExtrasLocked": "Extra sales are available on Pro. Upgrade to enable.",
    "businessTypeHelper": "This choice determines which books/reports you can export in Bookkeeping.",
    "chargeAbsentTitle": "Charge no-notice absences",
    "chargeAbsentDescription": "Default for new enrollments. Changing this here does not affect existing enrollments.",
    "chargeAbsentApplyAll": "Apply to all existing enrollments",
    "chargeAbsentApplyConfirmTitle": "Save the default and apply to all enrollments?",
    "chargeAbsentApplyConfirmBody1": "This saves the default above, and changes",
    "chargeAbsentApplyConfirmBody2": "monthly-billed enrollments and",
    "chargeAbsentApplyConfirmBody3": "term-billed enrollments. Applies to everything not yet invoiced, including the not-yet-closed month. For term enrollments, the entire running term will be re-counted.",
    "chargeAbsentApplyCancel": "Cancel",
    "chargeAbsentApplyConfirm": "Save and apply",
    "chargeAbsentApplyDone": "Saved the default and updated {{count}} enrollments",
    "maxExcusedTitle": "Max excused absences per month",
    "maxExcusedHint": "Past this count, the Excused button turns red when taking attendance. Leave blank for no limit.",
    "watermarkTitle": "Invoice watermark",
    "watermarkDescription": "Show the \"Made with LopHoc.app\" line on the public invoice page — a free way to help LopHoc.app spread.",
    "watermarkForcedNote": "The Free plan always shows the watermark.",
    "templateTitle": "Invoice message template",
    "templateDescription": "The message parents receive when you send an invoice by hand (the Send by hand tab).",
    "templateTokenPayer": "Parent",
    "templateTokenPeriod": "Period",
    "templateTokenStudents": "Students",
    "templateTokenTotal": "Total",
    "templateTokenLink": "Invoice link",
    "templateTokenDueDate": "Due date",
    "templateCharCount": "{{count}}/2000 characters",
    "templatePreviewTitle": "Preview",
    "templateRestoreDefault": "Restore default template",
    "templateHelper": "The chips above are just a quick insert — optional. The address (\"Thầy\"/\"Cô\") is plain text; edit it directly in the template. Clearing the editor and saving reverts to the default template.",
    "invoiceDueDayTitle": "Default invoice due day",
    "invoiceDueDayHint": "Applied when closing the month. Leave blank and the due date is 7 days after the invoice is created. You can also save it quickly from the close-month dialog."
  },
  "audit": {
    "filters": {
      "group": "Action group",
      "actor": "Actor",
      "from": "From",
      "to": "To",
      "toSep": "to",
      "clear": "Clear filters"
    },
    "groups": {
      "all": "All actions",
      "money": "Money",
      "students": "Students and enrollments",
      "clients": "Invoices and customers",
      "org": "Organisation",
      "other": "Other"
    },
    "actor": {
      "all": "Everyone",
      "platform": "LopHoc",
      "system": "System",
      "unknownMember": "Member"
    },
    "link": {
      "invoice": "View invoice",
      "student": "View student",
      "client": "View customer",
      "subject": "View subject"
    },
    "count": "{{count}} actions",
    "empty": "Nothing recorded yet.",
    "emptyFiltered": "No action matches these filters.",
    "loading": "Loading...",
    "error": "Could not load the log. Try again later.",
    "pager": {
      "summary": "Page {{page}} / {{pages}}",
      "prev": "Previous",
      "next": "Next"
    },
    "summary": {
      "bulk": "bulk delete",
      "monthReopened": "{{month}}/{{year}}, {{count}} draft invoices withdrawn",
      "modeSession": "Per session",
      "modeTerm": "Per term",
      "modeFlat": "Fixed monthly",
      "fromTo": "{{from}} to {{to}}",
      "chargeAbsentOn": "Unexcused absences now billed",
      "chargeAbsentOff": "Unexcused absences no longer billed",
      "chargeAbsentBulk": "{{state}} for {{count}} enrollments",
      "on": "On",
      "off": "Off",
      "tagsAdded": "Added: {{tags}}",
      "tagsRemoved": "Removed: {{tags}}",
      "payerPending": "{{count}} unpaid invoices keep the old payer",
      "template": "Template {{name}}: {{joined}} joined, {{left}} left",
      "progressLinks": "{{created}} links created, {{existing}} already existed",
      "monthClosed": "{{month}}/{{year}}, {{count}} invoices, {{total}} in total",
      "channelZalo": "via Zalo",
      "channelEmail": "via email",
      "tag": "Tag: {{tag}}",
      "fieldFromTo": "{{field}}: {{from}} to {{to}}",
      "memberInvited": "{{email}} as {{role}}",
      "memberRemoved": "{{name}}, {{slots}} slots archived, {{sessions}} future sessions removed",
      "bank": "{{bank}} ****{{last4}}",
      "branchSlots": "{{count}} slots into {{name}}",
      "upgrade": "{{plan}} plan, {{cycle}}, {{amount}}",
      "cycleMonthly": "monthly",
      "cycleAnnual": "annual",
      "invoiceUpdated": "{{code}}, changed {{fields}}",
      "invoiceUpdatedItems": "{{code}}, {{count}} lines added",
      "paymentFor": "{{amount}} for {{code}}",
      "sourceCash": "cash",
      "sourceBank": "external transfer",
      "sourceSepay": "auto-matched",
      "dueDateBulk": "{{count}} invoices, due {{date}}",
      "payrollAdjust": "{{amount}}, month {{month}}",
      "unlinked": "unlinked",
      "empty": "empty",
      "imported": "{{created}} students, {{skipped}} rows skipped",
      "withCount": "{{name}} · {{count}} {{unit}}",
      "unitStudents": "students",
      "unitEnrollments": "enrollments",
      "unitEntries": "entries",
      "slot": "{{subject}} · {{day}} {{time}}",
      "slotMembers": "{{subject}} · {{day}} {{time}} · {{count}} students",
      "classCreated": "Created class {{displayName}} ({{slotCount}} time slots)",
      "classUpdated": "Changed {{field}} on the class",
      "classArchived": "Archived class ({{slotCount}} time slots)",
      "classUnarchived": "Restored class ({{slotCount}} time slots)",
      "classCascaded": "cascaded from a time slot",
      "classMembersAdded": "Added {{n}} students to class {{displayName}}",
      "session": "{{subject}} · {{when}}",
      "sessionParticipants": "{{subject}} · {{when}} · {{count}} students",
      "movedTo": "{{name}} to the session on {{when}}",
      "day1": "Sun",
      "day2": "Mon",
      "day3": "Tue",
      "day4": "Wed",
      "day5": "Thu",
      "day6": "Fri",
      "day7": "Sat",
      "bankSwitch": "{{fromBank}} ****{{fromLast4}} to {{bank}} ****{{last4}}"
    },
    "actions": {
      "INVOICE_DELETED": "Invoice deleted",
      "INVOICE_CLIENT_CHANGED": "Invoice payer changed",
      "MONTH_REOPENED": "Closed month reopened",
      "PAYROLL_FINALIZED": "Payroll finalised",
      "PAYROLL_REOPENED": "Payroll reopened",
      "PAYER_REASSIGNED": "Student's payer changed",
      "PROMOTION_APPLIED": "Promotion applied to plan",
      "SEPAY_COMPANY_REMAPPED": "Bank connection remapped",
      "SEPAY_COMPANY_STATUS_CHANGED": "Bank connection status changed",
      "SEPAY_DEPOSIT_ADJUSTED": "Reconciliation deposit adjusted",
      "SEPAY_LINK_TOKEN_REVOKED": "Bank link token revoked",
      "SEPAY_UNLINK_STARTED": "Bank unlink started",
      "ENROLLMENT_CREATED": "Enrollment created",
      "ENROLLMENT_PAUSED": "Enrollment paused",
      "ENROLLMENT_RESUMED": "Enrollment resumed",
      "ENROLLMENT_ENDED": "Enrollment ended",
      "ENROLLMENT_RATE_CHANGED": "Rate changed",
      "ENROLLMENT_DELETED": "Enrollment deleted",
      "ENROLLMENT_CHARGE_ABSENT_CHANGED": "Absence-billing rule changed",
      "ENROLLMENT_CHARGE_ABSENT_BULK": "Absence-billing rule changed in bulk",
      "STUDENT_TAGS_CHANGED": "Tags updated",
      "STUDENT_DEACTIVATED": "Student deactivated",
      "STUDENT_REACTIVATED": "Student reactivated",
      "STUDENT_DELETED": "Student deleted",
      "STUDENT_PROGRESS_LINK_BULK_CREATED": "Progress links created in bulk",
      "SLOT_MEMBER_MOVED": "Student moved between classes",
      "SCHEDULE_TEMPLATE_APPLIED": "Schedule template applied",
      "INVITATION_REVOKED": "Member invitation revoked",
      "PLAN_ASSIGNED": "Plan assigned",
      "ORG_SUSPENDED": "Organisation suspended",
      "ORG_UNSUSPENDED": "Organisation unsuspended",
      "DEMO_ORG_RESET": "Demo data reset",
      "STUDENT_PROGRESS_LINK_CREATED": "Progress link created",
      "STUDENT_PROGRESS_LINK_ROTATED": "Progress link rotated",
      "SUBJECT_NOTE_TEMPLATE_UPDATED": "Note template updated",
      "SUBJECT_NOTE_TEMPLATE_REMOVED": "Note template removed",
      "MONTH_CLOSED": "Month closed",
      "CLIENT_INVOICE_CREATED": "Invoice created for customer",
      "CLIENT_INVOICE_SENT": "Invoice sent to customer",
      "CLIENT_INVOICE_PAID": "Customer paid",
      "CLIENT_INVOICE_OVERDUE": "Invoice overdue",
      "CLIENT_INVOICE_CANCELLED": "Invoice cancelled",
      "CLIENT_INVOICE_VIEWED": "Customer viewed invoice",
      "CLIENT_REMINDER_SENT": "Payment reminder sent",
      "CLIENT_NOTE_ADDED": "Customer note added",
      "CLIENT_NOTE_EDITED": "Customer note edited",
      "CLIENT_TAG_ADDED": "Customer tag added",
      "CLIENT_TAG_REMOVED": "Customer tag removed",
      "CLIENT_INFO_UPDATED": "Customer info updated",
      "ORG_INFO_UPDATED": "Organisation info updated",
      "ORG_SETTINGS_UPDATED": "Tuition rules changed",
      "ORG_PREFERENCES_UPDATED": "Display preferences changed",
      "MEMBER_INVITED": "Member invited",
      "MEMBER_ROLE_CHANGED": "Member role changed",
      "MEMBER_REMOVED": "Member removed",
      "MEMBER_PLACEHOLDER_CREATED": "Placeholder teacher added",
      "MEMBER_CONVERTED": "Placeholder converted to account",
      "BANK_LINKED": "Bank linked",
      "BANK_UNLINKED": "Bank unlinked",
      "BRANCH_CREATED": "Branch created",
      "BRANCH_UPDATED": "Branch updated",
      "BRANCH_ARCHIVED": "Branch archived",
      "BRANCH_UNARCHIVED": "Branch restored",
      "BRANCH_SLOTS_ASSIGNED": "Slots assigned to branch",
      "SUBSCRIPTION_UPGRADE_REQUESTED": "Plan upgrade requested",
      "SUBSCRIPTION_RENEWAL_STOPPED": "Renewal stopped",
      "SUBSCRIPTION_RENEWAL_RESUMED": "Renewal resumed",
      "SUBSCRIPTION_INVOICE_CANCELLED": "Plan invoice cancelled",
      "INVOICE_UPDATED": "Invoice edited",
      "PAYMENT_RECORDED": "Payment recorded",
      "PAYMENT_LINKED": "Transaction linked to invoice",
      "PAYMENT_IGNORED": "Unmatched transaction ignored",
      "PAYMENT_DELETED": "Payment deleted",
      "INVOICE_DUE_DATE_BULK": "Due dates changed in bulk",
      "EXPENSE_CREATED": "Expense added",
      "EXPENSE_UPDATED": "Expense edited",
      "EXPENSE_DELETED": "Expense deleted",
      "PAYROLL_ADJUSTMENT_CREATED": "Payroll adjustment added",
      "PAYROLL_ADJUSTMENT_DELETED": "Payroll adjustment deleted",
      "STUDENT_CREATED": "Student added",
      "STUDENT_UPDATED": "Student info edited",
      "STUDENTS_IMPORTED": "Students imported from file",
      "CLIENT_CREATED": "Customer added",
      "CLIENT_DELETED": "Customer deleted",
      "CLIENT_NOTE_DELETED": "Customer note deleted",
      "SUBJECT_CREATED": "Subject created",
      "SUBJECT_UPDATED": "Subject edited",
      "SUBJECT_DELETED": "Subject deleted",
      "SCHEDULE_TEMPLATE_CREATED": "Schedule template created",
      "SCHEDULE_TEMPLATE_UPDATED": "Schedule template edited",
      "SCHEDULE_TEMPLATE_DELETED": "Schedule template deleted",
      "SCHEDULE_TEMPLATE_ENTRIES_REPLACED": "Schedule template entries replaced",
      "SLOT_CREATED": "Class slot created",
      "SLOT_UPDATED": "Class slot edited",
      "SLOT_ARCHIVED": "Class slot archived",
      "SLOT_UNARCHIVED": "Class slot restored",
      "SLOT_MEMBER_ADDED": "Student added to slot",
      "SLOT_MEMBER_REMOVED": "Student removed from slot",
      "CLASS_CREATED": "Class created",
      "CLASS_UPDATED": "Class edited",
      "CLASS_ARCHIVED": "Class archived",
      "CLASS_UNARCHIVED": "Class restored",
      "CLASS_MEMBERS_ADDED": "Students added to class",
      "SESSION_CREATED": "Session created",
      "SESSION_UPDATED": "Session edited",
      "SESSION_CANCELLED": "Session cancelled",
      "SESSION_PARTICIPANT_ADDED": "Student added to session",
      "SESSION_PARTICIPANT_REMOVED": "Student removed from session",
      "SESSION_PARTICIPANT_MOVED": "Student moved to another session",
      "BANK_PRIMARY_CHANGED": "Receiving bank account changed"
    },
    "fields": {
      "invoiceDueDay": "Default due day",
      "invoiceMessageTemplate": "Tuition message template",
      "defaultChargeAbsent": "Bill unexcused absences by default",
      "name": "Name",
      "phone": "Phone",
      "email": "Email",
      "address": "Address",
      "businessType": "Business type",
      "teamSize": "Team size",
      "preferredChannel": "Preferred channel",
      "defaultCurrency": "Currency",
      "sellsExtras": "Sells extras",
      "showTeacherAssignment": "Show teacher assignment",
      "absenceQuota": "Excused absence quota",
      "watermark": "Watermark",
      "dueDate": "Due date",
      "notes": "Notes",
      "taxRate": "Tax",
      "depositAmount": "Deposit",
      "amount": "Amount",
      "category": "Category",
      "date": "Date",
      "description": "Description",
      "nickname": "Nickname",
      "gender": "Gender",
      "dateOfBirth": "Date of birth",
      "defaultRate": "Default rate per session",
      "defaultMonthlyRate": "Default monthly rate",
      "dayOfWeek": "Weekday",
      "startTime": "Start time",
      "startAt": "Start",
      "durationMin": "Duration (min)",
      "maxCapacity": "Capacity",
      "branchId": "Branch",
      "teachers": "Teachers",
      "teacherId": "Teacher",
      "note": "Note",
      "logoUrl": "Logo",
      "maxExcusedPerMonth": "Max excused absences per month",
      "showInvoiceWatermark": "Invoice watermark",
      "brandColor": "Brand colour",
      "classMode": "Class organization"
    }
  }
}
